import { applyCarstock } from "@gaiaherbs/Services/CarstockService";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { updateCart } from "@insite/client-framework/Services/CartService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import loadPromotions from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadPromotions";
import translate from "@insite/client-framework/Translate";
import { CartLineCollectionModel, CartLineModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Radio, { RadioStyle } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import { Draft } from "immer";
import cloneDeep from "lodash/cloneDeep";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface CartLinesListHeaderStyles {
    wrapper?: InjectableCss;
    productCountText?: TypographyPresentationProps;
    productListHeading?: TypographyPresentationProps;
    checkboxGroup?: FieldSetGroupPresentationProps<CheckboxGroupComponentProps>;
    condensedCheckbox?: CheckboxPresentationProps;
    selectReasonModal?: ModalPresentationProps;
    reasonListOptionRadioGroup?: RadioGroupProps;
    unmarkButtonWarpper?: InjectableCss;
    saveButton?: ButtonPresentationProps;
    cancelButton?: ButtonPresentationProps;
    reasonButtonWarpper?: InjectableCss;
    markAsFreeButton?: ButtonPresentationProps;
    unmarkAsFreeButton?: ButtonPresentationProps;
    spinnerWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    discountWarpper?: InjectableCss;
}

export const cartLinesListHeaderStyles: CartLinesListHeaderStyles = {
    wrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            /* border-bottom: 1px solid ${getColor("common.border")};
            padding-bottom: 10px; */
            flex-direction: column;
            margin-bottom: -8px;
        `,
    },
    spinnerWrapper: {
        css: css`
            display: flex;
            height: 100vh;
            z-index: 2000;
        `,
    },
    productCountText: {
        weight: 600,
        fontFamily: "Lato",
        css: css`
            @media print {
                font-weight: lighter;
                font-size: 16px;
            }
        `,
    },
    productListHeading: {
        variant: "h5",
        color: "primary",
        css: css`
            margin-bottom: 10px;
            padding: 0.5rem 1rem;
            font-size: 1.25rem;
            font-family: "LibreBaskerville";
            font-weight: normal;
            margin-right: auto;
            background-color: #f0f4f3;
            width: 100%;
            @media print {
                font-size: 24px !important;
                width: 100vw;
            }
        `,
    },
    checkboxGroup: {
        css: css`
            @media print {
                display: none;
            }
        `,
    },
    cancelButton: {
        variant: "secondary",
    },
    saveButton: {},
    selectReasonModal: {
        sizeVariant: "small",
        cssOverrides: {
            modalBody: css`
                border-radius: 6px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            border-radius: 0;
                        `,
                        css`
                            border-radius: 0;
                        `,
                        css`
                            border-radius: 0;
                        `,
                        null,
                        null,
                    ])}
            `,
            modalTitle: css`
                color: ${getColor("primary")};
                padding: 10px 15px;
                > h4 {
                    margin-bottom: 0;
                }
            `,
            modalContent: css`
                padding: 15px;
                padding-top: 5px;
            `,

            headlineTypography: css`
                font-size: 24px;
                font-family: LibreBaskerville;
            `,
        },
    },
    reasonListOptionRadioGroup: {
        css: css`
            flex-direction: column;
            & > ${RadioStyle} {
                margin-top: 10px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            flex-direction: column;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    unmarkButtonWarpper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;

            > span[class^="TypographyStyle"] {
                text-align: center;
            }
        `,
    },
    reasonButtonWarpper: {
        css: css`
            display: flex;
            justify-content: end;
            gap: 10px;
        `,
    },
    markAsFreeButton: {
        variant: "secondary",
    },
    unmarkAsFreeButton: { variant: "tertiary" },
    spinner: {
        size: 50,
        css: css`
            margin-right: 8px;
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
        `,
    },
    discountWarpper: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0rem 1rem;
        `,
    },
};

const mapStateToProps = (state: ApplicationState) => {
    const cart = getCurrentCartState(state).value;
    const userType = state.context.session.properties?.userType;
    const isEnabledCarstock = state.context.settings.properties?.isCarStockEnabled;
    const cartId = state.pages.orderConfirmation?.cartId;
    const cartState = getCartState(state, state.pages.orderConfirmation.cartId);
    const currentPage = getCurrentPage(state);

    return {
        cart,
        userType,
        isEnabledCarstock,
        cartId,
        cartState,
        currentPage,
    };
};

const mapDispatchToProps = { loadCart, loadPromotions, };

interface OwnProps {
    productsCount: number;
    isCondensed: boolean;
    hideCondensedSelector?: boolean;
    onChangeIsCondensed?: (event: React.SyntheticEvent, value: boolean) => void;
    extendedStyles?: CartLinesListHeaderStyles;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const CartLinesListHeader: FC<Props> = ({
    productsCount,
    onChangeIsCondensed,
    extendedStyles,
    isCondensed,
    hideCondensedSelector,
    cart,
    userType,
    loadCart,
    isEnabledCarstock,
    cartId,
    cartState,
    currentPage,
    loadPromotions,
}) => {
    const [isAllItemsCarstock, setIsAllItemsCarstock] = useState(true);
    const [isAllItemsAppliedCarstock, setIsAllItemsAppliedCarstock] = useState(true);
    const [isShowReasonModal, setIsShowReasonModal] = React.useState(false);
    const [reasonListOption, setReasonListOption] = React.useState("");
    const [isReasonError, setIsReasonError] = React.useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const isBroker = userType === "BROKER";

    const isOrderSubmitted = currentPage?.name !== "Checkout - Order Confirmation";

    useEffect(() => {
        setIsAllItemsCarstock(true);
        setIsAllItemsAppliedCarstock(true);
        if (cart && cart.cartLines) {
            cart.cartLines.forEach(item => {
                if (item.properties?.isCarstockProduct !== "true") {
                    setIsAllItemsCarstock(false);
                }
                if (item.properties?.isProductMarkedAsFreeForCarstock !== "true") {
                    setIsAllItemsAppliedCarstock(false);
                }
            });
        }
    }, [cart, cart?.cartLines]);

    const [styles] = React.useState(() => mergeToNew(cartLinesListHeaderStyles, extendedStyles));

    const productsLabel = productsCount > 1 ? "Items" : "Item";

    const handleApplyCarstockItems = async () => {
        const notes = reasonListOption;
        onHandleCloseModal();

        if (cart && cart.cartLines) {
            setIsLoading(true);
            const response = await applyCarstock({
                carstock: { Id: cart.trackId, AllProductCarstock: true, Notes: notes },
            });

            if (cart.lineCount > 0) {
                const cartClone = cloneDeep(cart) as Draft<typeof cart>;
                await updateCart({ cart: cartClone });
            }

            setIsLoading(false);
            if (response.successful === true) {
                setIsAllItemsAppliedCarstock(true);
            }
            await loadCart({ cartId: cart.id });
            await loadPromotions({ cartId: cart.id });
            // await loadCart({ cartId: cart.id });
            // window.location.reload()
        }
    };

    const handleRemoveCarstockItems = async () => {
        const notes = reasonListOption;
        onHandleCloseModal();

        if (cart && cart.cartLines) {
            setIsLoading(true);
            const response = await applyCarstock({
                carstock: { Id: cart.trackId, AllProductCarstock: false, Notes: notes },
            });

            if (cart.lineCount > 0) {
                const cartClone = cloneDeep(cart) as Draft<typeof cart>;
                await updateCart({ cart: cartClone });
            }

            setIsLoading(false);
            if (response.successful === true) {
                setIsAllItemsAppliedCarstock(false);
            }
            await loadCart({ cartId: cart.id });
            await loadPromotions({ cartId: cart.id });
            // await loadCart({ cartId: cart.id });
            // await window.location.reload()
        }
    };

    const onHandleMarkAsFreeButton = () => {
        setReasonListOption("");
        setIsShowReasonModal(true);
    };

    const onHandleCloseModal = () => {
        setIsShowReasonModal(false);
        setIsReasonError(false);
    };

    const reasonListOptionChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setReasonListOption(event.currentTarget.value);
    };

    const optionsString = siteMessage("Car_Stock_Reason") as string;
    const options = optionsString.split(",");

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.productListHeading}>{translate("Product Information")}</Typography>
            <StyledWrapper {...styles.discountWarpper}>
                <Typography {...styles.productCountText} as="h3">
                    {productsCount} {translate(productsLabel)}
                </Typography>
                {isEnabledCarstock !== "false" && isAllItemsCarstock && !isAllItemsAppliedCarstock && isOrderSubmitted && (
                    <Button
                        disabled={isLoading}
                        onClick={() => onHandleMarkAsFreeButton()}
                        {...styles.markAsFreeButton}
                    >
                        {siteMessage("Bulk_Mark_Free")}
                    </Button>
                )}
                {isEnabledCarstock !== "false" && isAllItemsCarstock && isAllItemsAppliedCarstock && isOrderSubmitted && (
                    <Button disabled={isLoading} onClick={handleRemoveCarstockItems} {...styles.markAsFreeButton}>
                        {siteMessage("Bulk_Unmark_As_Free")}
                    </Button>
                )}

                {isLoading && <LoadingSpinner {...styles.spinner} />}

                <Modal
                    headline={translate("Choose a Reason Code")}
                    {...styles.selectReasonModal}
                    isOpen={isShowReasonModal}
                    handleClose={() => onHandleCloseModal()}
                    data-test-selector="BudgetModal"
                >
                    {isReasonError && <Typography color="red"> Please choose reason code.</Typography>}

                    <RadioGroup
                        {...styles.reasonListOptionRadioGroup}
                        value={reasonListOption}
                        onChangeHandler={reasonListOptionChangeHandler}
                        data-test-selector="resonListOption"
                    >
                        {options.map(item => (
                            <Radio key={item} value={item}>
                                {item}
                            </Radio>
                        ))}
                    </RadioGroup>
                    <StyledWrapper {...styles.reasonButtonWarpper}>
                        <Button onClick={() => onHandleCloseModal()} {...styles.cancelButton}>
                            {translate("Cancel")}
                        </Button>
                        <Button onClick={handleApplyCarstockItems} {...styles.saveButton}>
                            {translate("Save")}
                        </Button>
                    </StyledWrapper>
                </Modal>
            </StyledWrapper>

            {/* Uncomment below code for condensed view checkbox */}
            {/* {!hideCondensedSelector && (
                <CheckboxGroup {...styles.checkboxGroup}>
                    <Checkbox {...styles.condensedCheckbox} checked={isCondensed} onChange={onChangeIsCondensed}>
                        {translate("Condensed View")}
                        <VisuallyHidden>{translate("for product list")}</VisuallyHidden>
                    </Checkbox>
                </CheckboxGroup>
            )} */}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(CartLinesListHeader);
